module.exports = __webpack_public_path__ + "static/media/fileUpload.3f305e5c.svg";